export default [
  { value: 'Date', align: 'center' },
  { value: 'Credit Ref #', align: 'center' },
  { value: 'Description', align: 'left' },
  { value: 'Applied To', align: 'center' },
  { value: 'Credit Amount', align: 'right' },
].map(({ value, align }, key) => ({ value, align, key }));
